export default __webpack_public_path__ + "static/media/waterfall_1280.c5fbb811.webp";